import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function MarketingProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [execs, setExecs] = useState([]);
  const reload = useCallback(async () => {
    const [s, e] = await Promise.all([api.get("/marketing/settings"), api.get("/marketing/executives")]);
    setSettings(s.data); setExecs(e.data);
  }, []);
  useEffect(() => { reload().catch(() => {}); }, [reload]);
  const stageOf = (key) => settings?.stages?.find((s) => s.key === key) || { key, label: key, color: "#71717a", kind: "open" };
  return <Ctx.Provider value={{ settings, execs, reload, stageOf }}>{children}</Ctx.Provider>;
}

export const useMarketing = () => useContext(Ctx);

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
export const fmtDT = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtD = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
export const isPast = (s) => !!s && new Date(s) < new Date();

export const PRIORITY_CLS = { Hot: "bg-rose-50 text-rose-700 border-rose-200", Warm: "bg-amber-50 text-amber-800 border-amber-200", Cold: "bg-sky-50 text-sky-700 border-sky-200" };

export function StagePill({ stage, stageOf, tid }) {
  const s = stageOf(stage);
  return <span data-testid={tid} className="inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 border border-zinc-200 bg-white whitespace-nowrap"><span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />{s.label}</span>;
}

export function Kpi({ label, value, sub, onClick, tid, accent }) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp data-testid={tid} onClick={onClick} className={`text-left border border-zinc-200 bg-white p-4 flex flex-col gap-1 ${onClick ? "hover:border-zinc-900 hover:-translate-y-0.5 transition-all" : ""} ${accent === "danger" && value ? "border-rose-300" : ""}`}>
      <div className="text-[10px] tracking-[0.16em] uppercase text-zinc-500 font-semibold">{label}</div>
      <div className={`font-heading font-black text-2xl tabular ${accent === "danger" && value ? "text-rose-600" : ""}`}>{value}</div>
      {sub ? <div className="text-[11px] text-zinc-500">{sub}</div> : null}
    </Comp>
  );
}
